import React from "react";
import { PieChart, Pie, Cell, ResponsiveContainer } from "recharts";

const COLORS = { low: "#22c55e", mid: "#eab308", high: "#ef4444" };
const TRACK = "#e2e8f0";

export default function GaugeWidget({ data, target = 100, latestTags, fullscreen }) {
    const latestValue = data && data.length > 0 ? data[data.length - 1].value : 0;
    const ratio = Math.min(latestValue / target, 1);
    const pct = Math.round(ratio * 100);

    const hasCapacity = latestTags && latestTags.capacity !== undefined && latestTags.used !== undefined;
    const usedRatio = hasCapacity ? latestTags.used / latestTags.capacity : null;

    const colorRatio = usedRatio !== null ? usedRatio : ratio;
    let color = COLORS.low;
    if (colorRatio >= 0.95) color = COLORS.high;
    else if (colorRatio >= 0.75) color = COLORS.mid;

    const inner = fullscreen ? 150 : 55;
    const outer = fullscreen ? 200 : 75;
    const chartH = fullscreen ? 420 : 160;

    const pieData = [
        { name: "Filled", value: ratio },
        { name: "Empty", value: 1 - ratio },
    ];

    const subText = hasCapacity
        ? `${latestTags.used}GB / ${latestTags.capacity}GB`
        : `${Number(latestValue).toLocaleString()} / ${Number(target).toLocaleString()}`;

    return (
        <div style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            padding: fullscreen ? "1rem 0" : "0.25rem 0",
        }}>
            <div style={{ width: fullscreen ? "100%" : 200, maxWidth: fullscreen ? 500 : 260 }}>
                <ResponsiveContainer width="100%" height={chartH}>
                    <PieChart isAnimationActive={false}>
                        <Pie
                            data={pieData}
                            cx="50%"
                            cy="100%"
                            startAngle={180}
                            endAngle={0}
                            innerRadius={inner}
                            outerRadius={outer}
                            dataKey="value"
                            isAnimationActive={false}
                            stroke="none"
                        >
                            <Cell fill={ratio > 0 ? color : TRACK} />
                            <Cell fill={TRACK} />
                        </Pie>
                    </PieChart>
                </ResponsiveContainer>
            </div>
            <div style={{
                textAlign: "center",
                marginTop: fullscreen ? "-10px" : 4,
            }}>
                <div style={{
                    fontSize: fullscreen ? "3rem" : "1.5rem",
                    fontWeight: 700,
                    lineHeight: 1,
                    color,
                }}>
                    {pct}%
                </div>
                <div style={{
                    fontSize: fullscreen ? "1rem" : "0.75rem",
                    color: "#64748b",
                    marginTop: 2,
                }}>
                    {subText}
                </div>
            </div>
        </div>
    );
}
